import CryptoJS from "crypto-js";

const AES_KEY = CryptoJS.enc.Base64.parse("r9xK2TlbN2TptilDgzLttqzAxNmga99C");
const AES_IV = CryptoJS.enc.Base64.parse("IpFC5gnqdi/cbNoXcPnY8w==");


export const encryptedValueKE = (data) => {
  try {
      // Convert data to string if it's not already
      const jsonString = typeof data === "string" ? data : JSON.stringify(data);

      // Encrypt the data
      const encrypted = CryptoJS.AES.encrypt(jsonString, AES_KEY, {
          iv: AES_IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      });

      // Return Base64-encoded string
      return encrypted.toString();
  } catch (error) {
      console.error("Encryption Error:", error.message);
      return null;
  }
};

// Decryption Function
export const decryptedValueKE = (encryptedData) => {
  try {
      if (!encryptedData) {
          throw new Error("Encrypted data is empty or undefined.");
      }

      // Decrypt the Base64-encoded data
      const decrypted = CryptoJS.AES.decrypt(encryptedData, AES_KEY, {
          iv: AES_IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
      });

      // Convert decrypted data back to a UTF-8 string
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

      // Attempt to parse JSON; if not JSON, return as string
      try {
          return JSON.parse(decryptedString);
      } catch {
          return decryptedString;
      }
  } catch (error) {
      console.error("Decryption Error:", error.message);
      return null;
  }
};
